const body = document.querySelector('body');
const scrollBody = document.querySelector('.search-hero');
let scrollContainer;
let searchHeroInput;
let searchHeroInputIcon;

if(scrollBody){
  scrollContainer = scrollBody.querySelector('.container');
  searchHeroInput = scrollBody && scrollBody.querySelector('#search-hero-input');
  searchHeroInputIcon = scrollBody && scrollBody.querySelector('#search-hero-input-icon');
}

const searchModal = document.querySelector('.modal-search');
const skip = document.querySelector('.skip-hero');
const targetMax = 0;
const targetMin = -75;
const loader = document.querySelector('.search-control__loader');

let targetScroll = targetMax;
let touchStartTargetScroll;
let touchStart = 0;
let canScroll = true;
const video = document.querySelector('video');
let isPaused = false;

const initHero = () => {
  if(scrollBody) {
    scrollContainer.classList.add('active');
    loader.classList.remove('active');

    const scrollFrames = {
      'slides':[
        {
          'target': '.image-1',
          'animations': [
            {
              'type': 'transform',
              'values': []
            },
            {
              'type': 'css',
              'values': [
                {
                  'attribute': 'right',
                  'start': 0,
                  'end': 0,
                  'scrollStart': -0,
                  'scrollEnd': -30,
                  'unit': '%',
                },
                {
                  'attribute': 'top',
                  'start': 0,
                  'end': -100,
                  'scrollStart': -20,
                  'scrollEnd': -30,
                  'unit': '%',
                },
                {
                  'attribute': 'width',
                  'start': 100,
                  'end': 50,
                  'scrollStart': -1,
                  'scrollEnd': -20,
                  'unit': '%',
                }
              ]
            }
          ]
        },
        {
          'target': '.image-2',
          'animations': [
            {
              'type': 'css',
              'values': [
                {
                  'attribute': 'top',
                  'start': 100,
                  'end': -100,
                  'scrollStart': -5,
                  'scrollEnd': -40,
                  'unit': '%',
                },
              ]
            }
          ]
        },
        {
          'target': '.image-3',
          'animations': [
            {
              'type': 'css',
              'values': [
                {
                  'attribute': 'top',
                  'start': 100,
                  'end': -100,
                  'scrollStart': -30,
                  'scrollEnd': -50,
                  'unit': '%',
                }
              ]
            }
          ]
        },
        {
          'target': '.image-4',
          'animations': [
            {
              'type': 'css',
              'values': [
                {
                  'attribute': 'top',
                  'start': 100,
                  'end': -100,
                  'scrollStart': -32,
                  'scrollEnd': -42,
                  'unit': '%',
                },
                {
                  'attribute': 'left',
                  'start': 10,
                  'end': 10,
                  'scrollStart': -32,
                  'scrollEnd': -52,
                  'unit': '%',
                }
              ]
            }
          ]
        },
        {
          'target': '.image-5',
          'animations': [
            {
              'type': 'css',
              'values': [
                {
                  'attribute': 'top',
                  'start': 100,
                  'end': -100,
                  'scrollStart': -35,
                  'scrollEnd': -48,
                  'unit': '%',
                },
                {
                  'attribute': 'right',
                  'start': 8,
                  'end': 8,
                  'scrollStart': -33,
                  'scrollEnd': -53,
                  'unit': '%',
                }
              ]
            }
          ]
        },
        {
          'target': '.image-6',
          'animations': [
            {
              'type': 'css',
              'values': [
                {
                  'attribute': 'top',
                  'start': 100,
                  'end': -100,
                  'scrollStart': -40,
                  'scrollEnd': -60,
                  'unit': '%',
                },
              ]
            }
          ]
        },
        {
          'target': '.image-7',
          'animations': [
            {
              'type': 'css',
              'values': [
                {
                  'attribute': 'top',
                  'start': 100,
                  'end': 0,
                  'scrollStart': -49,
                  'scrollEnd': -59,
                  'unit': '%',
                },
                {
                  'attribute': 'width',
                  'start': 150,
                  'end': 100,
                  'scrollStart': -60,
                  'scrollEnd': -75,
                  'unit': '%',
                },
              ]
            }
          ]
        },
        {
          'target': '.text-1',
          'animations': [
            {
              'type': 'css',
              'values': [
                {
                  'attribute': 'top',
                  'start': 100,
                  'end': -10,
                  'scrollStart': -10,
                  'scrollEnd': -50,
                  'unit': '%',
                }
              ]
            }
          ]
        },
        {
          'target': '.text-2__top',
          'animations': [
            {
              'type': 'css',
              'values': [
                {
                  'attribute': 'opacity',
                  'start': 0,
                  'end': 1,
                  'scrollStart': -20,
                  'scrollEnd': -30,
                  'reverseStart': -40,
                  'reverseEnd': -50,
                  'unit': '%',
                },
                {
                  'attribute': 'left',
                  'start': 1,
                  'end': 100,
                  'scrollStart': -20,
                  'scrollEnd': -50,
                  'unit': '%',
                }
              ]
            }
          ]
        },
        {
          'target': '.text-2__bottom',
          'animations': [
            {
              'type': 'css',
              'values': [
                {
                  'attribute': 'opacity',
                  'start': 0,
                  'end': 1,
                  'scrollStart': -20,
                  'scrollEnd': -30,
                  'reverseStart': -40,
                  'reverseEnd': -50,
                  'unit': '%',
                },
                {
                  'attribute': 'right',
                  'start': 1,
                  'end': 100,
                  'scrollStart': -20,
                  'scrollEnd': -50,
                  'unit': '%',
                }
              ]
            }
          ]
        },
        {
          'target': '.text-3',
          'animations': [
            {
              'type': 'css',
              'values': [
                {
                  'attribute': 'opacity',
                  'start': 0,
                  'end': 1,
                  'scrollStart': -45,
                  'scrollEnd': -50,
                  'reverseStart': -54,
                  'reverseEnd': -59,
                  'unit': '',
                },
                {
                  'attribute': 'top',
                  'start': 0,
                  'end': 25,
                  'scrollStart': -45,
                  'scrollEnd': -50,
                  'unit': '%',
                }
              ]
            }
          ]
        },
        {
          'target': '.text-4',
          'animations': [
            {
              'type': 'css',
              'values': [
                {
                  'attribute': 'opacity',
                  'start': 0,
                  'end': 1,
                  'scrollStart': -54,
                  'scrollEnd': -59,
                  'reverseStart': -64,
                  'reverseEnd': -69,
                  'unit': '',
                },
                {
                  'attribute': 'top',
                  'start': 0,
                  'end': 25,
                  'scrollStart': -54,
                  'scrollEnd': -59,
                  'unit': '%',
                }
              ]
            }
          ]
        },
        {
          'target': '.text-5',
          'animations': [
            {
              'type': 'css',
              'values': [
                {
                  'attribute': 'opacity',
                  'start': 0,
                  'end': 1,
                  'scrollStart': -64,
                  'scrollEnd': -69,
                  'unit': '',
                },
                {
                  'attribute': 'top',
                  'start': 0,
                  'end': 20,
                  'scrollStart': -64,
                  'scrollEnd': -69,
                  'unit': '%',
                }
              ]
            }
          ]
        },
      ]
    };

    scrollFrames.slides.forEach((item) => {
      const target = document.querySelector(item.target);

      if (target) {
        item.animations.forEach((anim) => {
          let animation = '';
          if(anim.type === 'transform'){
            anim.values.forEach((prop) => {
              animation += prop.attribute + '(' + prop.start + prop.unit + ') ';
            })
            target.style.transform = animation;
          } else {
            let step = null;
            anim.values.forEach((prop) => {
              step = prop.start;

              switch(prop.attribute){
                case 'opacity':
                  target.style.opacity = step;
                  break;
                case 'top':
                  target.style.top = step + prop.unit;
                  break;
                case 'bottom':
                  target.style.bottom = step + prop.unit;
                  break;
                case 'left':
                  target.style.left = step + prop.unit;
                  break;
                case 'right':
                  target.style.right = step + prop.unit;
                  break;
                case 'width':
                  target.style.width = step + prop.unit;
                  break;
              }
            })
          }
        })

      }
    })

    const handleScroll = (e) => {
      let x = Math.abs(e.deltaY / 100);
      targetScroll = e.deltaY > 0 ? targetScroll - x : targetScroll + x;

      if (targetScroll > targetMax){
        canScroll = true;
        targetScroll = targetMax;
      } else if (targetScroll < targetMin){
        canScroll = false;
        body.style.overflow = 'auto';
        targetScroll = targetMin;
      } else if(window.scrollY == 0){
        canScroll = true;
        body.style.overflow = 'hidden';
        e.preventDefault();
      }

      scrollContent(targetScroll);
    }

    const handleTouch = (e) => {
      if(touchStart == 0) {
        touchStart = e.targetTouches[0].screenY;
      } else {
        if(touchStart < e.targetTouches[0].screenY && targetScroll < targetMax && window.scrollY == 0) {
          targetScroll++;
          touchStart = e.targetTouches[0].screenY;
        } else if(targetScroll > targetMin && window.scrollY == 0) {
          targetScroll--;
          touchStart = e.targetTouches[0].screenY;
        }
      }

      if (targetScroll > targetMax){
        canScroll = true;
        targetScroll = targetMax;
      } else if (targetScroll <= targetMin){
        canScroll = false;
        body.style.overflow = 'auto';
        targetScroll = targetMin;
      } else if(window.scrollY == 0){
        canScroll = true;
        body.style.overflow = 'hidden';
      }

      scrollContent(targetScroll);
    }

    const handleTouchStart = (e) => {
      touchStartTargetScroll = targetScroll;
      touchStart = 0;
      if (window.scrollY <= 0 && canScroll) {
        e.preventDefault();
      } else {
        document.body.style.overflow = 'auto';
      }
    }

    const handleTouchEnd = (e) => {
      if (e.target === searchHeroInput && touchStartTargetScroll === targetScroll) {
        searchHeroInput.focus();
      }
      if (e.target === searchHeroInputIcon && touchStartTargetScroll === targetScroll) {
        openSearch();
      }
    }

    const scrollContent = (targetScroll) => {
      if(canScroll){
        scrollFrames.slides.forEach((item) => {
          const target = document.querySelector(item.target);
          if (target) {
            item.animations.forEach((anim) => {
              let animation = '';

              if(anim.type === 'transform'){
                let frame = 0;
                let step = 0;

                anim.values.forEach((prop) => {
                  if(prop.scrollStart >= targetScroll && prop.scrollEnd <= targetScroll){
                    frame = (Math.abs(targetScroll) - Math.abs(prop.scrollStart));

                    if(prop.start < prop.end){
                      step = frame * ((prop.end - prop.start) / (Math.abs(prop.scrollEnd) - Math.abs(prop.scrollStart)));
                    } else {
                      step = prop.start - (frame * ((prop.start - prop.end) / (Math.abs(prop.scrollEnd) - Math.abs(prop.scrollStart))));
                    }

                    animation += prop.attribute + '(' + step + prop.unit + ') ';
                  } else if(prop.scrollEnd > targetScroll) {
                    animation += prop.attribute + '(' + prop.end + prop.unit + ') ';
                  } else {
                    animation += prop.attribute + '(' + prop.start + prop.unit + ') ';
                  }
                })
                target.style.transform = animation;
              } else {
                let step = null;
                let frame = 0;

                anim.values.forEach((prop) => {
                  if(prop.scrollStart >= targetScroll && prop.scrollEnd <= targetScroll){
                    step = 0;
                    frame = (Math.abs(targetScroll) - Math.abs(prop.scrollStart));

                    if(prop.start < prop.end){
                      step = frame * ((prop.end - prop.start) / (Math.abs(prop.scrollEnd) - Math.abs(prop.scrollStart)));
                    } else {
                      step = prop.start - (frame * ((prop.start - prop.end) / (Math.abs(prop.scrollEnd) - Math.abs(prop.scrollStart))));
                    }
                  } else if(prop.reverseStart >= targetScroll && prop.reverseEnd <= targetScroll){
                    step = 0;
                    frame = (Math.abs(targetScroll) - Math.abs(prop.reverseStart));

                    if(prop.start > prop.end){
                      step = frame * ((prop.start - prop.end) / (Math.abs(prop.reverseEnd) - Math.abs(prop.reverseStart)));
                    } else {
                      step = prop.end - (frame * ((prop.end - prop.start) / (Math.abs(prop.reverseEnd) - Math.abs(prop.reverseStart))));
                    }
                  } else if(prop.reverseEnd > targetScroll) {
                    step = prop.start;
                  } else if(prop.scrollEnd > targetScroll) {
                    step = prop.end;
                  } else {
                    step = prop.start;
                  }

                  switch(prop.attribute){
                    case 'opacity':
                      target.style.opacity = step;
                      break;
                    case 'top':
                      target.style.top = step + prop.unit;
                      break;
                    case 'bottom':
                      target.style.bottom = step + prop.unit;
                      break;
                    case 'left':
                      target.style.left = step + prop.unit;
                      break;
                    case 'right':
                      target.style.right = step + prop.unit;
                      break;
                    case 'width':
                      target.style.width = step + prop.unit;
                      break;
                  }
                  //let setProp = styleObject.setProperty(prop.attribute, step);
                })
              }
            })
          }
        })

        scrollBody.setAttribute('data-frame', targetScroll);
      } else {
        body.style.overflow = 'auto';
      }
    }

    if (scrollBody != null) {
      scrollContainer.addEventListener('wheel', handleScroll);
      scrollContainer.addEventListener('touchmove', handleTouch);
      scrollContainer.addEventListener('touchstart', handleTouchStart, { passive: false });
      scrollContainer.addEventListener('touchend', handleTouchEnd, { passive: false });
      document.addEventListener('touchstart', () => {
        if (window.scrollY !== 0) {
          document.body.style.overflow = 'auto';
        }
      });
    }

    const handleSkip = (e) => {
      e.preventDefault();
      while (targetScroll >= targetMin) {
        targetScroll--;
        scrollContent(targetScroll);
      }

      body.style.overflow = 'auto';
      window.scrollTo(0, 100);
    }

    skip.addEventListener('click', handleSkip);

    if(!!window.IntersectionObserver && video){
      //video.pause();
      let observer = new IntersectionObserver((entries, observer) => {

        entries.forEach((entry) => {
          if(!entry.isIntersecting  && !video.paused){
            video.pause();
            isPaused = true;
          } else if(isPaused) {
            video.play();
            isPaused=false
          }
        });
      });
      observer.observe(video);
    }

    const openSearch = () => {
      searchModal.classList.add('modal-search--open');
      body.classList.add('body--scroll-locked');
      document.dispatchEvent(new CustomEvent("openSearchWithValue", {
        bubbles: true,
        detail: {
          value: searchHeroInput.value,
        }
      }));
      searchHeroInput.value = '';
    }

    if (searchHeroInput) {
      searchHeroInput.addEventListener('keydown', (event) => {
        if (event.key === 'Enter') {
          openSearch();
        }
      });
    }

    if (searchHeroInputIcon) {
      searchHeroInputIcon.addEventListener('click', openSearch);
    }
  }
}

const ready = (fn) => {
  if (document.readyState !== 'loading') {
    fn();
  } else {
    document.addEventListener('DOMContentLoaded', fn);
  }
}

ready(initHero);



// WEBPACK FOOTER //
// ./src/templates/components/search-hero/search-hero.js